<template>
  <div id="app">
    <v-app id="inspire">
      <app-toolbar></app-toolbar>
      <router-view/>
      <app-footer></app-footer>
    </v-app>
  </div>
</template>

<script>
import Toolbar from './components/page_structure/Toolbar.vue';
import Footer from './components/page_structure/Footer.vue';
export default {
  name: 'App',
  components: {
    'app-toolbar': Toolbar,
    'app-footer': Footer
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue